import React from "react"

export const FinancialAwarenessIcon: React.FC = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.88867 0C13.7978 0 17.7772 3.97962 17.7773 8.88867C17.7773 13.7979 13.7978 17.7773 8.88867 17.7773C3.97958 17.7772 1.23972e-05 13.7978 0 8.88867C0.000117333 3.9797 3.97964 0.000122796 8.88867 0ZM8.88867 1.30762C4.70158 1.30774 1.30773 4.70164 1.30762 8.88867C1.30763 13.0759 4.70151 16.4706 8.88867 16.4707C13.0759 16.4707 16.4707 13.0759 16.4707 8.88867C16.4706 4.70156 13.0759 1.30762 8.88867 1.30762ZM8.88867 3.66016C9.24955 3.66016 9.54282 3.95263 9.54297 4.31348V5.49023H11.1768C11.5375 5.49039 11.8299 5.78279 11.8301 6.14355C11.8301 6.50443 11.5376 6.7977 11.1768 6.79785H7.05859C6.66161 6.79798 6.33984 7.11966 6.33984 7.5166C6.34 7.91354 6.66174 8.23522 7.05859 8.23535H10.7188C11.8377 8.23535 12.7451 9.14272 12.7451 10.2617C12.745 11.3807 11.8377 12.2871 10.7188 12.2871H9.54297V13.4639C9.54297 13.8248 9.24964 14.1172 8.88867 14.1172C8.5278 14.1171 8.23535 13.8248 8.23535 13.4639V12.2871H6.60156C6.24059 12.2871 5.94727 11.9948 5.94727 11.6338C5.94737 11.2729 6.24066 10.9805 6.60156 10.9805H10.7188C11.1156 10.9805 11.4373 10.6587 11.4375 10.2617C11.4375 9.86469 11.1158 9.54297 10.7188 9.54297H7.05859C5.93977 9.54284 5.03238 8.63547 5.03223 7.5166C5.03223 6.39772 5.93968 5.49037 7.05859 5.49023H8.23535V4.31348C8.2355 3.9527 8.52789 3.66027 8.88867 3.66016Z"
        fill="#37474F"
      />
    </svg>
  )
}
